import Phaser from 'phaser';
import SpritePool from './SpritePool';
import SnowParticle from './SnowParticle';

export default class SnowMaker {
  constructor (scene, totalCount, totalTypes, container) {
    this.scene = scene;
    this.maxParticles = totalCount;
    this.typeCount = totalTypes;
    this.container = container;

    this.pool = null;
    this.active = null;

    this.isFalling = true;
    this.fallWaiter = -1;
    this.fallWaitTime = 0.25;
    this.fallBottomLimit = 400;

    this.setup();
  }

  setup() {
    this.pool = new SpritePool(SnowParticle, this.maxParticles, this.scene);
    this.active = [];
  }

  spawnSnow(x,y,vx, vy) {
    const s = this.pool.getSprite();
    if (s === null) return null;

    s.reset(x,y,vx, vy);
    this.container.add(s);
    this.active.push(s);
    return s;
  };

  returnSnow(item, index) {
    if (item.parentContainer) item.parentContainer.remove(item);
    this.scene.children.remove(item);

    this.active.splice(index,1);
    this.pool.returnSprite(item);
  };

  tick(dt) {
    if (this.isFalling) {
      if (this.fallWaiter <= 0) {
        this.spawnSnow(Phaser.Math.Between(25, this.scene.scale.width - 25), -10, 0, Phaser.Math.Between(3,10));
        this.fallWaiter = this.fallWaitTime;
      }
      else {
        this.fallWaiter -= dt;
      }
    }

    const len = this.active.length - 1;

    let alive = true;
    for (let i = len; i >= 0; i--) {
      alive = this.active[i].tick(dt);

      if (alive) {
        this.active[i].updatePos();
      }
      else {
        this.returnSnow(this.active[i], i);
      }
    }
  };
}